import { defaultOptions, passwordStrength } from "check-password-strength";

export function checkPassStrength(event, setStrength) {
    event.preventDefault();

    const customOptions = [...defaultOptions]
    customOptions[2].minDiversity = 3
    let strength = passwordStrength(event.target.value, customOptions)
    setStrength(strength.id)
  }